import { useTranslation } from "react-i18next";

function DeleteButton(props){
    const [t, i18n] = useTranslation("common");

    return(
        <button {...props}>
            <img src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`} className="m-0 mr-lg-2" alt="trash" />
            <span className="d-none d-lg-inline">{t(`button.delete`)}</span>
        </button>
    )
}

export default DeleteButton